import { getCountries, getFilteredCountries } from '@/redux/actions/countries'
import { getLanguages } from '@/redux/actions/languages'
import { getRoles } from '@/redux/actions/roles'
import { IRootState } from '@/redux/types'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

function useInitialState() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { languages } = useSelector((state: IRootState) => state.language)
  const { roles } = useSelector((state: IRootState) => state.role)

  const types = [
    { id: 0, name: t('admin.events.webinar') },
    { id: 1, name: t('admin.events.instagram-live') },
    { id: 2, name: t('admin.events.live') },
    { id: 3, name: t('admin.events.training') },
    { id: 4, name: t('admin.events.fair') },
    { id: 5, name: t('admin.events.question-session') },
    { id: 6, name: t('admin.events.launch') },
    { id: 7, name: t('admin.events.ftf-event') }
  ]
  const methods = [
    { id: 0, name: t('admin.events.custom') },
    { id: 1, name: t('Normal') }
  ]

  useEffect(() => {
    if (authUser.role_id === 1) dispatch(getCountries())
    else dispatch(getFilteredCountries())
    if (languages.length === 0) dispatch(getLanguages())
    if (roles.length === 0) dispatch(getRoles())
  }, [])

  return { types, methods }
}

export default useInitialState
